// frontend/src/pages/ResetPassword.jsx
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { passwordResetApi } from '../utils/api';
import toast from 'react-hot-toast';
import BrandIcon from '../components/BrandIcon';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('8 caractères minimum');
    if (password !== confirm) return toast.error('Les mots de passe ne correspondent pas');
    setLoading(true);
    try {
      await passwordResetApi.reset(token, password);
      setDone(true);
      toast.success('Mot de passe mis à jour');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Lien invalide ou expiré');
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-base)' }}>
        <div className="card" style={{ padding:28, maxWidth:400, textAlign:'center' }}>
          <p style={{ color:'var(--text-2)', marginBottom:16 }}>Lien de réinitialisation manquant ou invalide.</p>
          <a href="/mot-de-passe-oublie" className="btn btn-primary">Redemander un lien</a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-base)' }}>
      <div style={{ width:'100%', maxWidth:400, padding:'0 16px' }}>
        <div style={{ textAlign:'center', marginBottom:40 }}>
          <div style={{ display:'flex', justifyContent:'center', marginBottom:12 }}><BrandIcon size={52}/></div>
          <h1 style={{ fontSize:24, fontWeight:700, background:'linear-gradient(135deg,var(--accent-light),var(--teal))', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            Nouveau mot de passe
          </h1>
        </div>

        {done ? (
          <div className="card" style={{ padding:28, textAlign:'center' }}>
            <div style={{ fontSize:32, marginBottom:10 }}>✓</div>
            <p style={{ fontSize:14, color:'var(--text-2)', marginBottom:20 }}>Votre mot de passe a été mis à jour.</p>
            <a href="/login" className="btn btn-primary">Se connecter</a>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div className="card" style={{ padding:28 }}>
              <div className="form-group">
                <label className="form-label">Nouveau mot de passe</label>
                <input className="input" type="password" value={password} onChange={e=>setPassword(e.target.value)}
                  required placeholder="••••••••" autoFocus />
              </div>
              <div className="form-group" style={{marginBottom:0}}>
                <label className="form-label">Confirmer</label>
                <input className="input" type="password" value={confirm} onChange={e=>setConfirm(e.target.value)}
                  required placeholder="••••••••" />
              </div>
            </div>
            <button className="btn btn-primary w-full" disabled={loading} style={{justifyContent:'center', padding:'13px'}}>
              {loading ? <span className="spinner" style={{width:18,height:18}} /> : 'Réinitialiser le mot de passe'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
